const productsBrowserSort = () => ({
  open: false,
  openDelayed: false,

  get options() {
    return this.sortingOptions;
  },

  get activeLabel() {
    const { options, sort } = this;
    if (!sort) return options[0].label;
    const [field, direction] = sort.split('::');
    const activeOption = options.find((option) => option.field === field && option.direction === direction);
    return activeOption.label;
  },

  init() {
    this.$watch('open', async (open) => {
      await this.$nextTick();
      this.openDelayed = open;
    });

    this.$watch('activeLabel', (activeLabel, oldActiveLabel) => {
      if (activeLabel === oldActiveLabel) return;
      this.open = false;
    });
  },

  handleClickOutside() {
    if (this.openDelayed) {
      this.open = false;
    }
  },
});

export default productsBrowserSort;
